export default __webpack_public_path__ + "static/media/best-price.e487c458.png";